import moment from 'moment';

export const tokenKey = 'auth_token';
export const restaurantKey = 'restaurant_id';
export const acceptShowKey = 'not_accept';

class AuthService {
  static getToken = () => {
    return localStorage.getItem(tokenKey);
  }

  static setToken = token => {
    localStorage.setItem(tokenKey, token);
  }

  static logout = () => {
    localStorage.clear();
  }

  static setCurrentRestaurant = restaurantId => {
    localStorage.setItem(restaurantKey, restaurantId);
  }

  static getCurrentRestaurant = () => {
    return localStorage.getItem(restaurantKey);
  }

  static getNotAccept = id => {
    // TODO add every day logic
    return localStorage.getItem(`${id}_${acceptShowKey}`);
  };

  static setNotAccept = (id, time) => {
    return localStorage.setItem(`${id}_${acceptShowKey}`, time);
  }

  static removeNotAccept = (id, time) => {
    return localStorage.removeItem(`${id}_${acceptShowKey}`);
  };
}

export default AuthService;
